import { cn } from '@bem-react/classname';

export const cnCloseButton = cn('CloseButton');
